import { createContext, Dispatch, ReactNode, SetStateAction, useEffect, useState } from 'react'
import { AddressDTO, UserDTO } from '@ringo/shared'
import { useUser } from './useUser'
import Loader from '../../../components/common/Loader'

export type UserDTOWithAddresses = UserDTO & { addresses?: AddressDTO[] | null }

interface AuthContext {
    user: UserDTOWithAddresses | null
    setUser: Dispatch<SetStateAction<UserDTO | null>>
}

export const AuthContext = createContext<AuthContext>({
    user: null,
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    setUser: () => {},
})

export const AuthContextProvider = ({ children }: { children: ReactNode }) => {
    const [user, setUser] = useState<UserDTOWithAddresses | null>(null)

    return (
        <AuthContext.Provider value={{ user, setUser }}>
            <AuthContextSetter>{children}</AuthContextSetter>
        </AuthContext.Provider>
    )
}

export const AuthContextSetter = ({ children }: { children: ReactNode }) => {
    const { refreshUserData, isLoading } = useUser()
    useEffect(() => {
        refreshUserData()
    }, [])

    return isLoading ? <Loader withBackdrop></Loader> : children
}
